import React, { useContext } from 'react';

import { Droppable } from 'react-beautiful-dnd';

import { AssignContext } from '../../AssignProvider';

import VenueAssignedPack from './VenueAssignedPack';

export default function VenuePacks(props) {
    const { dates } = props;
    const { filteredPacks } = useContext(AssignContext);

    return (
        <div className="tw-space-y-2">
            {(filteredPacks.length > 0 &&
                filteredPacks.map((p) => (
                    <div key={p.packId.toString() + p.amount.toString()}>
                        <VenueAssignedPack packId={p.packId} amount={p.amount} />
                    </div>
                ))) || <></>}

            {dates.length > 0 && (
                <Droppable droppableId="venue-packs">
                    {(provided, screnshot) => {
                        return (
                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                <div className="tw-rounded-lg tw-border-2 tw-border-dashed tw-border-gray-200 tw-bg-gray-50 tw-text-center tw-p-4">
                                    {$t('Drag and Drop Pack')}
                                </div>
                                <div className="d-none">{provided.placeholder}</div>
                            </div>
                        );
                    }}
                </Droppable>
            )}
        </div>
    );
}
